import { useEffect } from 'react';

import Navbar from '../components/Navbar/Navbar';
import Appointment from '../sections/Appointment/Appointment';
import Banner from '../sections/Banner/Banner';
import More from '../sections/More/More';
import Partner from '../sections/Partner/Partner';
import Footer from '../sections/Footer/Footer';
import Services from '../sections/Services/Services';
import Smile from '../sections/Smile/Smile';

const Home = () => {
    useEffect(() => {
        document.title = 'Zahnarzt Bielefeld – Pankraz & Lichagin';

        document
            .querySelector('meta[name="description"]')
            ?.setAttribute(
                'content',
                'Zahnarztpraxis Pankraz & Lichagin in Bielefeld-Milse. Moderne Zahnmedizin, Zahnersatz, Prophylaxe, Wurzelbehandlung und Zahnästhetik.'
            );
    }, []);

    return (
        <>
            <Navbar />
            <Banner />
            <Smile />
            <Services />
            <Partner />
            <More />
            <Appointment />
            <Footer />
        </>
    );
};

export default Home;